import { FreeIcon, StopwatchIcon, TouchIcon } from '../../atoms/icons'
import FigCaption from '../../molecules/FigCaption'


const bannerContent = [
    {
        icon: TouchIcon,
        caption: "User-friendly interface"
    },
    {
        icon: StopwatchIcon,
        caption: "24/7 customer support"
    },
    {
        icon: FreeIcon,
        caption: "No money charged on your first month"
    },
]

export default function HeroBanner() {
    return (
        <section
            role="banner"
            className="flex justify-evenly items-center py-6 px-10 bg-secondary2"
        >


            {
                bannerContent.map((bannerItem, index)=>(
                    <FigCaption 
                        Figure={bannerItem.icon}
                        caption={bannerItem.caption}
                        key={index}
                    />
                ))
            }


        </section>
    )
}
